import React, { useContext } from "react";
import { DataTable, HighlightMatch, Table } from "@sscs/ui";
import { getQueryStatus } from "@sscs/utils";
import { FILE_BROWSER_ROUTES } from "../../../constants";
import { expandedRowPaginationUpdated, expandedRowSortUpdated, expandedRowsUpdated, focusedRowUpdated, selectExpandedRow, selectExpandedRowPagination, selectExpandedRowSort, selectFocusedRow, } from "../../../store/behaviorSlice";
import { ComponentList, ExpandedRowDetails } from "../../../ui";
import { BehaviorCategory, BehaviorExplanation, BehaviorMaliciousness, ComponentName, ComponentPriorityAndIssuesLink, PrevalenceDetails, PrevalenceSummary, } from "../../common";
import { ReportContext } from "../../context";
import { useReportDispatch, useReportSelector } from "../../hooks";
import { useGetBehaviorSourcesQuery } from "../../services/behavior.api";
const BehaviourDetails = ({ behaviour, index, searchRegex, }) => {
    var _a;
    const { reportId } = useContext(ReportContext);
    const dispatch = useReportDispatch();
    const expanded = useReportSelector((state) => selectExpandedRow(state, behaviour.identifier));
    const pagination = useReportSelector((state) => selectExpandedRowPagination(state, behaviour.identifier));
    const sortBy = useReportSelector((state) => selectExpandedRowSort(state, behaviour.identifier));
    const focusedRow = useReportSelector(selectFocusedRow);
    const { data, isFetching, isLoading, isError, error } = useGetBehaviorSourcesQuery({
        ui_item_id: behaviour.identifier,
        pagination: pagination,
        sort: sortBy,
        ui_id: reportId,
    }, { skip: !expanded });
    const handleSortChange = (newSort) => {
        dispatch(expandedRowSortUpdated({
            id: behaviour.identifier,
            sort: newSort,
        }));
    };
    return (React.createElement(DataTable.ExpandedRow, { id: `behavior-expand-row-${index}`, key: behaviour.identifier, expanded: expanded, onChange: (isExpanded) => dispatch(expandedRowsUpdated({ id: behaviour.identifier, expand: isExpanded })), focused: focusedRow === behaviour.identifier, onClick: () => dispatch(focusedRowUpdated(behaviour.identifier)) },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, null,
                React.createElement(BehaviorCategory, { category: behaviour.category })),
            React.createElement(Table.Cell, null, behaviour.identifier),
            React.createElement(Table.Cell, null,
                React.createElement(HighlightMatch, { value: behaviour.description, regex: searchRegex }),
                React.createElement(PrevalenceSummary, { prevalence: behaviour.prevalence })),
            React.createElement(Table.Cell, null, behaviour.component_count.toLocaleString())),
        React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(ExpandedRowDetails, null,
                React.createElement(ExpandedRowDetails.Aside, null,
                    React.createElement(BehaviorExplanation, { explanation: behaviour.explanation }),
                    React.createElement(BehaviorMaliciousness, { maliciousness: behaviour.maliciousness, total: behaviour.total }),
                    React.createElement(PrevalenceDetails, { prevalence: behaviour.prevalence, repositoryStatistics: behaviour.repository_statistics })),
                React.createElement(ExpandedRowDetails.Main, null,
                    React.createElement(ComponentList.Table, { itemId: "behavior", rowIndex: index, title: "Components that exhibit this behavior", matchCount: (_a = data === null || data === void 0 ? void 0 : data.match_count) !== null && _a !== void 0 ? _a : 0, queryStatus: getQueryStatus({
                            isLoading,
                            isFetching,
                            isError,
                            error,
                            data,
                        }), totalCount: behaviour.component_count, pagination: pagination, onPaginationChange: (newPagination) => dispatch(expandedRowPaginationUpdated({
                            id: behaviour.identifier,
                            pagination: newPagination,
                        })), columns: ComponentList.columns({
                            sortBy,
                            rowIndex: index,
                            onSortChange: handleSortChange,
                        }) }, data === null || data === void 0 ? void 0 : data.components.map((component, index) => { var _a; return (React.createElement(Table.Row, { key: (_a = component.id) !== null && _a !== void 0 ? _a : component.path },
                        React.createElement(Table.Cell, null, React.createElement(ComponentList.PriorityAndIssues, { component: component, id: index.toString(), badgeWrapper: (target, children) => (React.createElement(ComponentPriorityAndIssuesLink, { htmlId: index.toString(), componentId: component.id, componentPath: component.path, target: target }, children)) })),
                        React.createElement(Table.Cell, null,
                            React.createElement(ComponentName, { component: component, id: index.toString(), fileBrowserPage: FILE_BROWSER_ROUTES.BEHAVIOR_ROUTE })),
                        React.createElement(Table.Cell, null,
                            React.createElement(ComponentList.Path, { path: component.path })))); })))))));
};
export default BehaviourDetails;
//# sourceMappingURL=BehaviourDetails.js.map